module.exports = "/_next/static/images/appearance_in-8916433997b9d6a67c8d0874565383af.png";